(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["decal-preview"] && !Shopify.designMode) return;
  try {
    class AEDecalPreview extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.shopify-section');
      this.liveRegion = this.querySelector('[data-live-region]');
      this.previewColor = this.querySelector('[data-preview-color]');
      this.previewView = this.querySelector('[data-preview-view]');
      this.previewShirt = this.querySelector('[data-preview-shirt]');
      this.variantImageUrl = this.dataset.initialShirtUrl || '';
      this.slots = [...this.querySelectorAll('[data-decal-slot]')].map((element) => {
        const id = element.dataset.decalSlot;
        return {
          id,
          element,
          decalInputs: [...element.querySelectorAll('[data-decal-input]')],
          artworkInputs: [...element.querySelectorAll('[data-artwork-input]')],
          artworkFieldset: element.querySelector('[data-artwork-fieldset]'),
          sizeFieldset: element.querySelector('[data-size-fieldset]'),
          placementFieldset: element.querySelector('[data-second-placement-fieldset]'),
          placementInputs: [...element.querySelectorAll('[data-placement-input]')],
          placementSummary: element.querySelector('[data-placement-summary]'),
          placementText: element.querySelector('[data-placement-text]'),
          previewArt: this.querySelector(`[data-preview-art][data-slot="${id}"]`),
          properties: {
            decal: this.querySelector(`[data-property="decal"][data-slot="${id}"]`),
            size: this.querySelector(`[data-property="size"][data-slot="${id}"]`),
            placement: this.querySelector(`[data-property="placement"][data-slot="${id}"]`),
            artwork: this.querySelector(`[data-property="artwork"][data-slot="${id}"]`),
          },
        };
      });
      this.handlePickerChange = this.handlePickerChange.bind(this);
      this.handleSectionChange = this.handleSectionChange.bind(this);
      this.handleVariantUpdate = this.handleVariantUpdate.bind(this);
      this.addEventListener('change', this.handlePickerChange);
      this.section?.addEventListener('change', this.handleSectionChange);
      this.section?.addEventListener('variant:update', this.handleVariantUpdate);
      this.legacyTimers = [0, 500, 1500, 3000].map((delay) => window.setTimeout(() => this.hideLegacyOptions(), delay));
      this.refresh(false);
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.handlePickerChange);
      this.section?.removeEventListener('change', this.handleSectionChange);
      this.section?.removeEventListener('variant:update', this.handleVariantUpdate);
      this.legacyTimers?.forEach((timer) => window.clearTimeout(timer));
    }

    handlePickerChange(event) {
      if (!event.target.matches('[data-decal-input], [data-artwork-input], [data-size-input], [data-placement-input]')) return;
      this.refresh(false);
    }

    handleSectionChange(event) {
      if (!event.target.closest('variant-picker')) return;
      window.setTimeout(() => this.refresh(true), 0);
    }

    handleVariantUpdate(event) {
      const variantImageUrl = event.detail?.resource?.featured_media?.preview_image?.src;
      if (variantImageUrl) this.variantImageUrl = variantImageUrl;
      window.setTimeout(() => this.refresh(true), 0);
    }

    getColor() {
      const variantPicker = this.section?.querySelector('variant-picker');
      if (!variantPicker) return (this.dataset.initialColor || '').trim().toLowerCase();
      const fieldsets = [...variantPicker.querySelectorAll('fieldset')];
      const colorFieldset = fieldsets.find((fieldset) => {
        const name = fieldset.querySelector('legend')?.textContent?.trim().toLowerCase();
        return name?.startsWith('color') || name?.startsWith('colour');
      });
      const checkedColor = colorFieldset?.querySelector('input:checked');
      if (checkedColor) return checkedColor.value.trim().toLowerCase();
      const colorSelect = [...variantPicker.querySelectorAll('select')].find((select) => /options\[(color|colour)\]/i.test(select.name));
      return (colorSelect?.value || this.dataset.initialColor || '').trim().toLowerCase();
    }

    getSelectedDecal(slot) {
      return slot.element.querySelector('[data-decal-input]:checked');
    }

    getSelectedArtwork(slot) {
      return slot.element.querySelector('[data-artwork-input]:checked');
    }

    getSelectedSize(slot) {
      if (slot.id === '2') return 'small';
      return slot.element.querySelector('[data-size-input]:checked')?.value || 'large';
    }

    getSelectedPlacement(slot) {
      if (slot?.id !== '2') return '';
      return slot.element.querySelector('[data-placement-input]:checked')?.value || this.dataset.secondSleevePlacement || 'left-sleeve';
    }

    isBackView() {
      const secondSlot = this.slots.find((slot) => slot.id === '2');
      return this.getSelectedDecal(secondSlot)?.value !== 'none' && this.getSelectedPlacement(secondSlot) === 'back-neckline';
    }

    isDarkShirt(color) {
      if (color.includes('light blue')) return false;
      return (
        color.includes('black') ||
        color.includes('blue') ||
        color.includes('navy') ||
        color.includes('green') ||
        color.includes('olive')
      );
    }

    isArtworkDesign(design) {
      return ['ae-baseball', 'gorilla-ae-baseball', 'gorilla-baseball', 'gorilla'].includes(design);
    }

    isFlatWhiteIncompatible(color) {
      if (!color) return false;
      return (
        color.includes('white') ||
        color.includes('light blue') ||
        color.includes('tan') ||
        color.includes('sand')
      );
    }

    isArtworkIncompatible(artwork, color) {
      if (this.isDarkShirt(color)) return artwork === 'black';
      if (color.includes('white')) return artwork === 'white';
      if (color.includes('grey') || color.includes('gray')) return artwork === 'chrome';
      return false;
    }

    getColorSlug(color) {
      return color.replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    }

    isPlacementProfileApproved(color) {
      const profiles = {
        'mens-champion-dri-fit': ['black', 'blue', 'grey', 'white'],
        'mens-champion-hoodie': ['black', 'green'],
        'mens-champion-t-shirt': ['black', 'grey', 'tan', 'green'],
        'mens-champion-t-shirt-big-tall': ['tan', 'green'],
        'mens-under-armour-velocity-jacquard-short-sleeve': ['black-anthracite', 'castlerock'],
        'mens-under-armour-velocity-short-sleeve': ['black', 'pitch-gray-light-heather'],
        'paragonxp-adult-performance-pullover-hoodie-big-tall': ['black', 'graphite', 'aluminum-grey'],
        'threadfast-adult-t-shirts': ['black', 'heather-grey', 'white'],
        'womens-champion-hoodie': ['green', 'black', 'grey'],
        'womens-champion-t-shirt': ['grey', 'white', 'black', 'blue'],
        'womens-champion-dri-fit': ['grey', 'white', 'light-blue', 'black'],
        'youth-champion-t-shirt': ['black', 'grey', 'white', 'blue'],
      };
      return profiles[this.dataset.productHandle]?.includes(this.getColorSlug(color)) === true;
    }

    setPurchaseBlocked(blocked) {
      this.section?.querySelectorAll('button[type="submit"][name="add"]').forEach((button) => {
        if (blocked && !button.disabled) {
          button.disabled = true;
          button.dataset.decalProfileBlocked = 'true';
        }
        if (!blocked && button.dataset.decalProfileBlocked === 'true') {
          button.disabled = false;
          delete button.dataset.decalProfileBlocked;
        }
      });
    }

    refresh(announceChange) {
      const color = this.getColor();
      const placementApproved = this.isPlacementProfileApproved(color);
      let changed = false;

      this.slots.forEach((slot) => {
        slot.decalInputs.forEach((input) => {
          const disabled =
            (!placementApproved && input.value !== 'none') ||
            (input.value === 'homeplate' && color.includes('black')) ||
            (input.value === 'flat-white-gorilla' && this.isFlatWhiteIncompatible(color));
          input.disabled = disabled;
          input.closest('label')?.toggleAttribute('aria-disabled', disabled);
        });

        if (this.getSelectedDecal(slot)?.disabled) {
          const replacement = slot.decalInputs.find((input) => !input.disabled);
          if (replacement) replacement.checked = true;
          changed = true;
        }

        slot.artworkInputs.forEach((input) => {
          const disabled = this.isArtworkIncompatible(input.value, color);
          input.disabled = disabled;
          input.closest('label')?.toggleAttribute('aria-disabled', disabled);
        });

        if (this.getSelectedArtwork(slot)?.disabled) {
          const replacement = slot.artworkInputs.find((input) => !input.disabled);
          if (replacement) replacement.checked = true;
          changed = true;
        }

        this.updateFields(slot, color);
        this.updatePreviewArt(slot, color);
      });

      if (this.liveRegion) {
        if (!placementApproved) this.liveRegion.textContent = this.dataset.placementUnavailableMessage || '';
        if (placementApproved && announceChange && changed) this.liveRegion.textContent = this.dataset.changedMessage || '';
      }
      this.updateShirtPreview(color);
      this.updateCheckoutControls();
      this.setPurchaseBlocked(!placementApproved);
      this.hideLegacyOptions();
    }

    updateFields(slot, color) {
      const decalInput = this.getSelectedDecal(slot);
      const design = decalInput?.value || 'none';
      const hasDecal = design !== 'none';
      const hasArtworkChoice = this.isArtworkDesign(design);
      const sizeKey = design === 'homeplate' ? 'standard' : this.getSelectedSize(slot);
      let placement = '';
      let artwork = '';

      if (hasDecal) {
        if (design === 'homeplate' || sizeKey === 'large') placement = this.dataset.centerChest || '';
        if (sizeKey === 'medium') {
          placement = this.dataset.mediumPlacement === 'right-chest'
            ? this.dataset.rightChest || ''
            : this.dataset.leftChest || '';
        }
        if (sizeKey === 'small') {
          const selectedPlacement = this.getSelectedPlacement(slot);
          if (selectedPlacement === 'back-neckline') placement = this.dataset.backNeckline || '';
          if (selectedPlacement === 'right-sleeve') placement = this.dataset.rightSleeve || '';
          if (selectedPlacement === 'left-sleeve') placement = this.dataset.leftSleeve || '';
        }
      }

      if (hasArtworkChoice) artwork = this.getSelectedArtwork(slot)?.dataset.lineValue || '';
      if (design === 'banner') artwork = this.isDarkShirt(color) ? this.dataset.bannerLightLabel : this.dataset.bannerDarkLabel;
      if (design === 'flat-white-gorilla') artwork = this.dataset.flatWhiteArtworkLabel || '';

      if (slot.artworkFieldset) slot.artworkFieldset.hidden = !hasArtworkChoice;
      if (slot.sizeFieldset) slot.sizeFieldset.hidden = !hasDecal || design === 'homeplate';
      if (slot.placementFieldset) slot.placementFieldset.hidden = !hasDecal;
      slot.placementSummary.hidden = !hasDecal;
      slot.placementText.textContent = placement;
      this.setProperty(slot.properties.decal, hasDecal ? decalInput.dataset.lineValue || '' : '');
      this.setProperty(slot.properties.size, hasDecal ? this.dataset[`${sizeKey}Size`] || sizeKey : '');
      this.setProperty(slot.properties.placement, placement);
      this.setProperty(slot.properties.artwork, artwork);
    }

    setProperty(input, value) {
      if (!input) return;
      input.value = value;
      input.disabled = !value;
    }

    getSlotProperties(slot) {
      const properties = {};
      if (!slot) return properties;
      Object.values(slot.properties).forEach((input) => {
        if (!input || input.disabled || !input.value) return;
        const name = input.name.match(/^properties\[(.*)\]$/)?.[1];
        if (name) properties[name] = input.value;
      });
      return properties;
    }

    getPrimaryCartProperties() {
      return this.getSlotProperties(this.slots.find((slot) => slot.id === '1'));
    }

    getSecondDecalCartItem(quantity, parentId) {
      const slot = this.slots.find((item) => item.id === '2');
      if (!slot || this.getSelectedDecal(slot)?.value === 'none') return null;
      return {
        id: Number(this.dataset.secondAddonVariantId),
        quantity,
        parent_id: Number(parentId),
        properties: this.getSlotProperties(slot),
      };
    }

    updateCheckoutControls() {
      const secondSlot = this.slots.find((slot) => slot.id === '2');
      const hasSecondDecal = this.getSelectedDecal(secondSlot)?.value !== 'none';
      this.section
        ?.querySelector('[ref="acceleratedCheckoutButtonContainer"]')
        ?.toggleAttribute('hidden', hasSecondDecal);
    }

    getColorKey(color) {
      if (color.includes('light blue')) return 'LightBlue';
      if (color.includes('black')) return 'Black';
      if (color.includes('blue') || color.includes('navy')) return 'Blue';
      if (color.includes('green') || color.includes('olive')) return 'Green';
      if (color.includes('grey') || color.includes('gray') || color.includes('steel') || color.includes('castlerock')) return 'Grey';
      if (color.includes('tan') || color.includes('sand')) return 'Tan';
      if (color.includes('white')) return 'White';
      return '';
    }

    getShirtUrl(color) {
      const view = this.isBackView() ? 'back' : 'front';
      const colorKey = this.getColorKey(color);
      const mappedUrl = colorKey ? this.dataset[`${view}${colorKey}Url`] : '';
      return mappedUrl || this.variantImageUrl || this.dataset.initialShirtUrl || '';
    }

    getArtwork(design, color, slot) {
      if (design === 'homeplate') return { url: this.dataset.homeplateUrl, blend: 'normal' };
      if (design === 'flat-white-gorilla') return { url: this.dataset.flatWhiteGorillaUrl, blend: 'normal' };
      if (design === 'banner') {
        return {
          url: this.isDarkShirt(color) ? this.dataset.bannerLightUrl : this.dataset.bannerDarkUrl,
          blend: 'normal',
        };
      }
      if (!this.isArtworkDesign(design)) return { url: '', blend: 'normal' };
      const artwork = this.getSelectedArtwork(slot)?.value || 'black';
      return {
        url: this.getArtworkUrl(design, artwork),
        blend: artwork === 'black' ? 'multiply' : 'screen',
      };
    }

    getArtworkUrl(design, artwork) {
      const lookup = {
        'ae-baseball': {
          black: this.dataset.aeBaseballBlackUrl,
          chrome: this.dataset.aeBaseballChromeUrl,
          white: this.dataset.aeBaseballWhiteUrl,
        },
        'gorilla-ae-baseball': {
          black: this.dataset.gorillaAeBaseballBlackUrl,
          chrome: this.dataset.gorillaAeBaseballChromeUrl,
          white: this.dataset.gorillaAeBaseballWhiteUrl,
        },
        'gorilla-baseball': {
          black: this.dataset.gorillaBaseballBlackUrl,
          chrome: this.dataset.gorillaBaseballChromeUrl,
          white: this.dataset.gorillaBaseballWhiteUrl,
        },
        gorilla: {
          black: this.dataset.gorillaBlackUrl,
          chrome: this.dataset.gorillaChromeUrl,
          white: this.dataset.gorillaWhiteUrl,
        },
      };
      return lookup[design]?.[artwork] || '';
    }

    updateShirtPreview(color) {
      const shirtUrl = this.getShirtUrl(color);
      this.dataset.previewColorKey = this.getColorSlug(color);
      if (this.previewShirt?.getAttribute('src') !== shirtUrl) this.previewShirt?.setAttribute('src', shirtUrl);
      if (this.previewColor) this.previewColor.textContent = color ? color.replace(/^./, (letter) => letter.toUpperCase()) : '';
      if (this.previewView) this.previewView.textContent = this.isBackView() ? this.dataset.backView : this.dataset.frontView;
    }

    updatePreviewArt(slot, color) {
      const design = this.getSelectedDecal(slot)?.value || 'none';
      const size = design === 'homeplate' ? 'standard' : this.getSelectedSize(slot);
      let placement = '';
      if (design === 'homeplate' || size === 'large') placement = 'center-chest';
      if (size === 'medium') placement = this.dataset.mediumPlacement || 'left-chest';
      if (size === 'small') placement = this.getSelectedPlacement(slot) || 'left-sleeve';

      const artwork = this.getArtwork(design, color, slot);
      const shouldHide = design === 'none' || !artwork.url || (slot.id === '1' && this.isBackView());
      if (!slot.previewArt) return;
      slot.previewArt.hidden = shouldHide;
      if (shouldHide) return;
      if (slot.previewArt.getAttribute('src') !== artwork.url) slot.previewArt.setAttribute('src', artwork.url);
      slot.previewArt.dataset.design = design;
      slot.previewArt.dataset.size = size;
      slot.previewArt.dataset.placement = placement;
      slot.previewArt.dataset.blend = artwork.blend;
    }

    hideLegacyOptions() {
      if (!this.section) return;
      const selector = '[class*="easify" i], [id*="easify" i], [data-app*="easify" i], [data-easify-options]';
      this.section.querySelectorAll(selector).forEach((element) => {
        if (this.contains(element) || element.contains(this) || ['SCRIPT', 'STYLE', 'LINK'].includes(element.tagName)) return;
        element.hidden = true;
        element.style.setProperty('display', 'none', 'important');
        element.setAttribute('aria-hidden', 'true');
        element.querySelectorAll('input, select, textarea, button').forEach((control) => {
          control.disabled = true;
        });
      });
    }
  }

  if (!customElements.get('decal-preview')) customElements.define('decal-preview', AEDecalPreview);
  } catch(e) { console.error(e); }
})();

})();
